export const PageUrls = {
  home: ``,
  project: (projectId: number | string) => `/projects/${projectId}`,
  assessment: (
    projectId: number | string,
    assessmentId: number | string,
    activeSection: number | string = 1,
  ) =>
    `/projects/${projectId}/assessments/${assessmentId}/section/${activeSection}`,
  anonymous_assessment: (
    projectId: number | string,
    assessmentId: number | string,
    activeSection: number | string = 1,
  ) =>
    `/projects/${projectId}/anonymous-assessments/${assessmentId}/section/${activeSection}`,
  report: (projectId: number | string, assessmentId: number | string) =>
    `/projects/${projectId}/assessments/${assessmentId}/report`,
  anonymous_report: (projectId: number | string, assessmentId: number | string) =>
    `/projects/${projectId}/anonymous-assessments/${assessmentId}/report`,
  thank_you: (projectId: number | string, assessmentId: number | string) =>
    `/projects/${projectId}/anonymous-assessments/${assessmentId}/thank-you`,
  hierarchy:()=>`/organisations/hierarchy`,
  userHierarchy:()=>`/organisations/userHierarchy`,
  userAssessment:()=>`/user/userAssessment`,
  SiPM:()=>`/organisations/SiPM`,
  InsightsHub:()=>`/organisations/InsightsHub`,
}

export const Breadcrumbs = {
  profile: [
    {
      text: `Profile`,
      href: `/profile`,
    },
  ],
}
